export enum AdminSideMenuItem {
  Users = "Korisnici",
  Programs = "Programi",
  Questionnaires = "Upitnici",
  Reports = "Izvještaji",
}
